import React from 'react';

const ProcessingStep = () => (
  <div className="convert-step convert-step--centered" aria-busy="true">
    <span className="convert-step__big-spinner" aria-hidden />
    <p className="convert-step__big-title">Your conversion is in progress</p>
    <p className="convert-step__muted">Do not close this page.</p>
  </div>
);

export { ProcessingStep };
